import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-graduated-2019',
  templateUrl: './graduated-2019.component.html',
  styleUrls: ['./graduated-2019.component.scss']
})
export class Graduated2019Component implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
